import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
/**
* @public
*/
const SortIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsx("svg", {
		"data-sanity-icon": "sort",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: /* @__PURE__ */ jsx("path", {
			d: "M8.5 18.5V6M16.5 19V6.5M12 15L8.5 18.5L5 15M13 10L16.5 6.5L20 10",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		})
	});
});
export { SortIcon, SortIcon as default };

//# sourceMappingURL=Sort.js.map